<mat-label class="margin-left-small margin-right-small"
  >
  <mat-form-field class="card-inline margin-right-small">
    <mat-label>Transacción</mat-label>
    <input [formControl]="control" type="text" matInput />
    <mat-icon *ngIf="readonly && enabledEdition" (click)="edit()" matSuffix>edit</mat-icon>
    <mat-icon *ngIf="!readonly" (click)="done()" matSuffix>done</mat-icon>
    <mat-icon *ngIf="!readonly" (click)="cancel()" matSuffix>cancel</mat-icon>
  </mat-form-field>
</mat-label>
